import { FC } from 'react';

import { Card, Cell, CellText, Radio, VSpacing } from '@hh.ru/magritte-ui';

import { ContextVacancy } from 'src/models/resumeSearchContext';

const DIVIDER = '・';

interface Props {
    vacancy: ContextVacancy;
    selectedVacancyId: number;
    setSelectedVacancy: (value: ContextVacancy) => void;
}

const ContextVacancyOption: FC<Props> = ({ vacancy, selectedVacancyId, setSelectedVacancy }) => {
    return (
        <Card padding={16} stretched>
            <Cell
                align="top"
                left={<Radio checked={vacancy.id === selectedVacancyId} readOnly />}
                onChange={() => setSelectedVacancy(vacancy)}
                data-qa="resume-search-context-vacancy-selector-option"
            >
                <CellText data-qa="resume-search-context-vacancy-selector-option-name">{vacancy.name}</CellText>
                {vacancy.filters.trls.length > 0 && (
                    <>
                        <VSpacing default={4} />
                        <CellText type="subtitle" data-qa="resume-search-context-vacancy-selector-option-filters">
                            {vacancy.filters.trls.join(DIVIDER)}
                        </CellText>
                    </>
                )}
            </Cell>
        </Card>
    );
};

export default ContextVacancyOption;
